import React from 'react'
import DashboardContainer from 'containers/Dashboard'

const DashboardPage = () => <DashboardContainer />

export default DashboardPage
